import { useToggle } from '../../../hooks/useToggle.mjs';

function useTogglePasswordField(params) {
  const { defaultVisible = false } = params;
  const [inputType, toggleInputType] = useToggle(defaultVisible ? "text" : "password", ["text", "password"]);
  return [inputType, toggleInputType];
}

export { useTogglePasswordField };
//# sourceMappingURL=useTogglePasswordField.mjs.map
